export interface IState {
    videoSrc: string | null
    mediaRecorder: MediaRecorder | null
    isRecording: boolean
    isUploading: boolean
    timer: number
    showModal: boolean
    randomPhrase: string
}

export interface IAction {
    type:
        | 'SET_VIDEO_SOURCE'
        | 'SET_MEDIA_RECORDER'
        | 'SET_IS_RECORDING'
        | 'SET_IS_UPLOADING'
        | 'SET_TIMER'
        | 'SET_SHOW_MODAL'
        | 'SET_RANDOM_PHARSE'
    payload?: any
}

export const initialState = {
    videoSrc: null,
    mediaRecorder: null,
    isRecording: false,
    isUploading: false,
    timer: 6,
    showModal: false,
    randomPhrase: '',
}
